import {
  AfterViewChecked,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  NgZone,
  ViewEncapsulation,
  ViewChild,
  OnDestroy,
  inject,
} from "@angular/core";
import { Router, Event, ResolveEnd, ActivationEnd, NavigationEnd } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { FormControl } from "@angular/forms";

import { Platform, MenuController, ModalController } from "@ionic/angular";
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';

import Bowser from "bowser";
// import OneSignal from "onesignal-cordova-plugin";

import { Addresses } from "src/providers/customer/addresses";
import { Events } from "src/providers/events/events";
import { Logger } from "src/providers/logger";
import { LoadingBarHandler } from "src/providers/loading-bar-handler/loading-bar-handler";
import { Menu } from "src/providers/menu/menu";
import { isClientHubPath, isPossibleProWebsitePath } from 'src/providers/guard/pro-website-redirect.guard';
import { StaticCompanyText } from "src/providers/company/static-company-text";
import { TidySession } from "src/providers/tidy-session/tidy-session";
import { TrackParams } from "src/providers/tidy-session/track-params.interface";
import { UtmService } from "src/providers/utm/utm.service";

import { CustomNavController } from "src/shared/providers/navigation/custom-nav-controller";
import { Loading } from "src/shared/components/loading/loading";
import { Util } from "src/shared/util/util";
import { navRootOptions } from "src/shared/constants/rootNavigation";
import { TidyStorage } from "src/shared/providers/tidy-storage";
import { WindowService } from "src/shared/providers/window.service";

import { BREAK_LARGE_RESOLUTION } from "android/app/src/constants/app.contants";

import { CookieService } from "ngx-cookie";
import { environment } from "src/environments/environment";
import { OneSignalNotification } from "src/shared/providers/one-signal-notification";
import { RightSidePanelService } from "src/shared/providers/providers/right-side-panel";
import { Capacitor } from "@capacitor/core";
import { register } from 'swiper/element/bundle';
import { Subscription } from "rxjs";
import { Client } from "src/providers/client/client";
import { Pros } from "src/providers/pros/pros";
import { HeaderProvider } from "src/providers/header/header";
import { TidyAbbreviateLastName } from "src/shared/pipes/tidy-abbr-lastname.pipe";
import { TranslationPipe } from "src/shared/pipes/translation.pipe";
import { findUnsearchableItems } from "src/shared/util/search-items-diagnostics";
import * as Sentry from '@sentry/angular';
import { BookService } from 'src/shared/services/book.service';
import { MyProPage } from "src/pages/my-pros/my-pro/my-pro";
import { AddressChangeService } from "src/providers/address-change/address-change";
import { AppUpdateService } from "src/shared/services/app-update.service";
import { Auth } from "src/providers/auth/auth";
import { propertyDashboardPath } from "src/providers/guard/rental-routes.guard";
import { AuthModalService } from "src/shared/services/auth-modal.service";
import { DemoAccountService } from "src/shared/services/demo-account.service";
import { DemoTourService } from "src/shared/services/demo-tour.service";
import { AccountManagerService } from "src/shared/services/account-manager.service";
import { OptimizerSaveBarService } from "src/shared/services/optimizer-save-bar.service";
import { DEMO_ACCOUNT_EMAIL } from "src/shared/services/demo-data.service";
import { GetStartedFlowComponent } from "src/shared/components/get-started-flow/get-started-flow.component";
import { OnboardingStatusComponent } from "src/shared/components/onboarding-status/onboarding-status.component";
import { AccountManagerModalComponent } from "src/shared/components/account-manager-modal/account-manager-modal.component";
import { ChatDockService } from "src/shared/services/chat-dock.service";
import { ThemeService } from "src/shared/services/theme.service";
import { FullScreenLoadingService } from "src/shared/services/full-screen-loading.service";
import { PosthogService } from "src/shared/services/posthog.service";
import { PmDemoLandingService } from "src/shared/services/pm-demo-landing.service";
import { SseService, SSE_EVENT_TYPES } from "src/shared/services/sse.service";
import { CustomRouteReuseStrategy } from "src/custom-route-reuse-strategy";


// Register Swiper custom elements (only in browser)
if (typeof document !== 'undefined' && document.documentElement) {
  register();
}

declare const window: any;
declare const document: any;

import { translations } from 'src/shared/constants/language-translations';
import { DesktopNavComponent } from "src/shared/components/desktop-nav/desktop-nav.component";
import { injectQueryClient } from '@tanstack/angular-query-experimental';

@Component({
    selector: "app-root",
    templateUrl: "app.html",
    styleUrls: ["./app.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TidyHomekeepingAppComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild(DesktopNavComponent) desktopNav: DesktopNavComponent;
  @ViewChild('globalSearchInput') globalSearchInput: ElementRef;

  filteredSearchItems: any[];
  nameAndAddress: any;
  private searchItems: any[];
  searchControl = new FormControl('');
  private searchSubscription: Subscription;
  private routerSubscription: Subscription;
  private eventSubscriptions: Subscription[] = [];
  private popstateHandler: (event: PopStateEvent) => void;
  private domNodeInsertedHandler: () => void;
  selectedSearchItem: any = null;
  showSearchOverlay = false;
  hideNavBar = false;
  menuType = "desktop";
  width = typeof document !== 'undefined' && document.documentElement ? document.documentElement.clientWidth : 0;
  currentComponent: any;
  addressSelectorOpened = false;
  enableMenu = false;
  pagesToShowHeader = false;
  translations = translations;
  capacitor = Capacitor;
  backgroundColor = '#1D2125';
  isNavCollapsed = false; // Default to expanded (showing text)
  appliedGiftCode: { code: string; appliedAt: number } | null = null;
  demoWelcomeLeaving = false;

  readonly breakLargeResolution = BREAK_LARGE_RESOLUTION;
  showAuthOverlay = !localStorage.getItem('tidy_token');

  get isNativePlatform(): boolean {
    return this.capacitor.isNativePlatform();
  }

  get isDesktopView(): boolean {
    return this.windowService?.isDesktopRes;
  }

  get isMobileView(): boolean {
    return !this.windowService?.isDesktopRes;
  }

  private queryClient = injectQueryClient();
  private appUpdateService = inject(AppUpdateService);

  constructor(
    private addresses: Addresses,
    private addressChangeService: AddressChangeService,
    private auth: Auth,
    private authModalService: AuthModalService,
    public demoAccountService: DemoAccountService,
    private demoTourService: DemoTourService,
    private client: Client,
    private cookieService: CookieService,
    private events: Events,
    public fullScreenLoadingService: FullScreenLoadingService,
    private headerProvider: HeaderProvider,
    private loadingBarHandler: LoadingBarHandler,
    private logger: Logger,
    public mainMenu: Menu,
    private menu: MenuController,
    private modalController: ModalController,
    private navCtrl: CustomNavController,
    private oneSignalNotification: OneSignalNotification,
    private platform: Platform,
    private posthogService: PosthogService,
    private pros: Pros,
    private sseService: SseService,
    public rightSidePanelService: RightSidePanelService,
    private router: Router,
    private staticCompanyText: StaticCompanyText,
    private storage: TidyStorage,
    private tidySession: TidySession,
    private titleService: Title,
    private util: Util,
    private elementRef: ElementRef,
    public windowService: WindowService,
    private utmService: UtmService,
    private zone: NgZone,
    private themeService: ThemeService,
    private bookService: BookService,
    private pmDemoLanding: PmDemoLandingService,
    private accountManagerService: AccountManagerService,
    public optimizerSaveBar: OptimizerSaveBarService
  ) {
    this.platform.ready().then(() => {
      this.initDeeplinks();
    });
  }

  ngOnInit() {
    // Flush any stale OLD-paradigm rental guest session so the user re-enters
    // through the new demo-account flow (fire-and-forget: no-op for everyone else).
    this.logoutIfStaleRentalGuest();
    // A concierge "login as client" deep link (/login/<jwt>) swaps out any existing session.
    // Hand that swap entirely to LoginPage: open the logout-on-401 suppression window now (so
    // stray 401s from the OUTGOING session can't wipe the new one and bounce to the auth modal)
    // and skip firing authed bootstrap requests with the outgoing token below.
    const isTokenLogin = this.isTokenLoginUrl();
    if (isTokenLogin) {
      this.auth.beginTokenLogin();
    }
    const currentUrl = window.location.hash?.replace('#/', '/') || window.location.pathname;
    const isCreateAccountTypeRoute = /\/create-account\//.test(currentUrl);
    const isAddFirstPropertyRoute = /\/add-first-property\//.test(currentUrl);
    const isOnboardingRoute = isCreateAccountTypeRoute || isAddFirstPropertyRoute;
    const isRentalDemoRoute = /\/create-account\/rental\b/.test(currentUrl);
    if (isCreateAccountTypeRoute && !this.auth.isAuthenticated()) {
      // The rental route logs into the PM demo and shows its own "Preparing Demo"
      // entrance cover, so open with that instead of the create-account bowtie overlay
      // (which would otherwise sit behind the cover and reappear when it lifts).
      if (isRentalDemoRoute) {
        this.demoAccountService.beginEntrance();
      } else {
        this.fullScreenLoadingService.show();
      }
    }
    if (!this.auth.isAuthenticated() && (this.isNativePlatform || !isPossibleProWebsitePath(window.location.pathname, this.router.config))) {
      history.replaceState({ guestSessionStart: true }, '');
      history.pushState({}, '');
      const currentPath = window.location.hash.replace('#', '') || window.location.pathname;
      // /demo-preview must be public: it boots an offline preview session while
      // unauthenticated, and this check otherwise wins the race against that
      // page's own ngOnInit (opening the guest modal / native-landing first).
      const isPublicRoute = isTokenLogin || currentPath.startsWith('/login') || currentPath.startsWith('/password-recovery') || currentPath.startsWith('/create-account/') || currentPath.startsWith('/add-first-property/') || currentPath.startsWith('/shared-link') || currentPath.startsWith('/past-shared-job') || currentPath.startsWith('/native-landing') || currentPath.startsWith('/demo-preview') || isClientHubPath(currentPath);
      if (!isPublicRoute && !localStorage.getItem('pendingPartnerCode')) {
        if (this.isNativePlatform) {
          this.navCtrl.navigateRoot('native-landing');
        } else {
          this.authModalService.openGuestTypeModal();
        }
      }
    } else if (this.auth.isAuthenticated() && !isTokenLogin) {
      this.sseService.connect([...SSE_EVENT_TYPES]);
    }
    const savedCollapsedState = localStorage.getItem('navMenuCollapsed');
    this.isNavCollapsed = savedCollapsedState === 'true';
    if (!isOnboardingRoute || this.auth.isAuthenticated()) {
      this.enableMenu = true;
    }
    // Initialize UTM service to capture UTMs from URL
    this.utmService.initialize();

    const wasLoggedOutDueToCacheIssue = localStorage.getItem('wasLoggedOutDueToCacheIssue') === 'true';
    if (wasLoggedOutDueToCacheIssue) {
      localStorage.removeItem('wasLoggedOutDueToCacheIssue');
      this.util.showError('There was an issue with your cache so we logged you out. Please log back in. We apologize for the inconvenience.', 10000);
    }
    this.loadAppliedGiftCode();
    this.demoAccountService.resumeWelcomeIfPending();
    // Mid-tour reloads resume the guided demo tour (no-op unless one was in progress
    // and the welcome card isn't re-showing).
    this.demoTourService.resumeIfPending();
    // During a login-as-client swap the outgoing session is about to be replaced — LoginPage
    // refreshes the pill on `auth:complete` once the new session is live. Firing it here would
    // hit the backend with the outgoing token (and risk a suppressed-but-noisy 401).
    if (!isTokenLogin) {
      this.refreshLivePill();
    }
    // Counts can change while a dialog is open (property added, step completed),
    // so re-check whenever one closes. If an account was just created from the demo
    // (Get Started flow), reload so the displayed page drops its demo data and shows the
    // new account's real data — cached routes were already cleared at conversion.
    this.rightSidePanelService.afterPanelClosed().subscribe(() => {
      if (this.demoAccountService.consumePendingRealDataReload()) {
        window.location.reload();
        return;
      }
      this.refreshLivePill();
    });
    this.addPopStateListener();
    this.preventiveRemoveAriaOwns();
    this.isUnsupportedBrowser();
    this.subscribeEvents();
    this.setBackground();
    this.menuType =
      this.width > this.breakLargeResolution ? "desktop" : "mobile";
    this.setVersion();
    this.storage.delete('proId');
    this.storage.delete('dialog-params');
    this.storage.delete('dialog-right-side-open');
    this.routerSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof ActivationEnd && event) {
        try {
          this.tidySession.setfirstUrlViewed(event?.snapshot?.url);
          this.trackUserNavigation(event);
        } catch (error) {
          this.logger.log(error);
        }
      }
      if (event instanceof ResolveEnd){
        this.setTitle(event);
        this.setBackground();
        this.setNameAddress();
      }
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        if (!this.isGettingStartedRoute(url)) {
          this.themeService.clearForcedDarkMode();
        }
        this.posthogService.screen(url).catch(() => {
          // Silently handle PostHog screen tracking errors
        });
      }
    });
  }

  private isGettingStartedRoute(url: string): boolean {
    return url.startsWith('/getting-started') ||
           url === '/onboarding/addPros' ||
           url.startsWith('/go-live');
  }

  // Matches the concierge "login as client" deep link (/login/<jwt>) whether the app booted on
  // the hash route (#/login/…) or the raw path (/login/…). Used to hand the session swap
  // entirely to LoginPage (no guest modal, no stale authed bootstrap, no logout-on-401).
  private isTokenLoginUrl(): boolean {
    const url = `${window.location.hash || ''} ${window.location.pathname || ''}`;
    return /\/login\/[^/?#\s]+/.test(url);
  }

  loadAppliedGiftCode() {
    try {
      const stored = localStorage.getItem('appliedGiftCode');
      if (stored) {
        this.appliedGiftCode = JSON.parse(stored);
      }
    } catch {
      this.appliedGiftCode = null;
    }
  }

  dismissGiftCode() {
    localStorage.removeItem('appliedGiftCode');
    this.appliedGiftCode = null;
  }

  get isDemoSession(): boolean {
    return this.demoAccountService.isDemoSession();
  }

  // The guided tour's dock occupies the bottom-center slot; the demo pill yields
  // to it and returns when the tour closes.
  get isDemoTourActive(): boolean {
    return this.demoTourService.active();
  }

  // Only once the entrance is fully over ('idle') so the pill's spring-in plays
  // on screen rather than hidden behind the sweep or welcome overlay.
  get showDemoFloatingPill(): boolean {
    return this.isDemoSession && this.demoAccountService.entrancePhase() === 'idle';
  }

  // True only when a floating bottom pill (demo nudge or live-onboarding) is
  // actually rendered — mirrors the @if conditions in app.html. Both pills are
  // desktop-only, so this is false on mobile.
  get hasFloatingPill(): boolean {
    if (!this.isDesktopView) { return false; }
    const liveShown = this.showLivePill && !this.isDemoSession;
    const demoShown = this.showDemoFloatingPill && !this.showLivePill;
    return liveShown || demoShown;
  }

  // Publish the floating pill's footprint as a global CSS variable so the chat &
  // messages inputs can reserve space for it (see their scss). Set imperatively
  // from change detection (deduped) so it's always correct on client-side
  // navigation — a host-class + descendant selector wouldn't re-match until a
  // refresh, which is the bug this replaces.
  private lastPillClearancePx = -1;
  ngAfterViewChecked(): void {
    const px = this.hasFloatingPill ? 80 : 0;
    if (px !== this.lastPillClearancePx) {
      this.lastPillClearancePx = px;
      document.documentElement.style.setProperty('--floating-pill-clearance', `${px}px`);
    }
  }

  showLivePill = false;
  livePropertiesCount = 0;
  livePropertiesTotal = 0;
  actionItemsCount = 0;
  callScheduled = false;
  setupCallCompleted = false;
  // Concierge-set target go-live date, pre-formatted for display (e.g. "Aug 15, 2026"), or
  // null when unset — the pill only shows the "Go Live Date" chip when this is present.
  targetGoLiveDateDisplay: string | null = null;
  // The customer's assigned account manager (from /me) shown on the pill / More-page card.
  managerName = AccountManagerService.DEFAULT.name;
  managerPhoto = AccountManagerService.DEFAULT.photoUrl;
  // Briefly expands/highlights the pill when its contents change (e.g. an action item
  // was completed) after a dialog closes, to draw the eye to what updated.
  livePillAttention = false;
  private lastPillSignature: string | null = null;

  // The post-conversion pill: converted rental accounts see their live count, any pending
  // action items (only when they chose a personalized projection), and whether their
  // setup call is scheduled.
  async refreshLivePill(): Promise<void> {
    if (!this.demoAccountService.isConvertedRentalAccount()) {
      this.showLivePill = false;
      this.demoAccountService.clearOnboardingNudge();
      this.lastPillSignature = null;
      return;
    }
    // A converted rental always shows the account-manager pill. Commit to showing it BEFORE the
    // async data loads so a transient fetch failure — common right after a login-as-client
    // session swap, and previously the reason the pill only appeared after a hard refresh — can
    // never leave it hidden. Worst case it shows with the default manager/counts until the next
    // refresh succeeds.
    this.showLivePill = true;
    try {
      // Source pill counts from the SAME data as the onboarding-status page, so the badge
      // and the page never diverge.
      const [assigned, callScheduled, callCompleted, manager, targetGoLiveDate, subscribeCompleted] = await Promise.all([
        this.demoAccountService.getAssignedActionItemsByAddress(),
        this.demoAccountService.isSetupCallScheduled(),
        this.demoAccountService.isSetupCallCompleted(),
        this.accountManagerService.getDisplay(),
        this.demoAccountService.getTargetGoLiveDate(),
        this.demoAccountService.isSubscribeStepCompleted(),
      ]);
      this.managerName = manager.name;
      this.managerPhoto = manager.photoUrl;
      this.targetGoLiveDateDisplay = this.demoAccountService.formatGoLiveDate(targetGoLiveDate);
      // "X of Y live" counts EVERY address the user has added (not just those with assigned
      // items) — so adding a property immediately shows "0 of 1".
      this.livePropertiesCount = assigned.filter((a) => a.isLive).length;
      this.livePropertiesTotal = assigned.length;
      this.callScheduled = callScheduled;
      this.setupCallCompleted = callCompleted;
      // Outstanding action items: concierge-assigned todos, plus the default "Tell Us About
      // Your Listings" and "Subscribe" items the status page surfaces per address (one each
      // per address still missing that step). When no property exists yet, the standalone
      // placeholder shows both (Subscribe only until the account has subscribed). Mirrors the
      // onboarding-status page's showConnectListingsFor / showSubscribeFor so the badge and
      // the page never diverge.
      let outstanding = assigned.reduce(
        (sum, a) => sum + a.items.filter((i) => !i.done).length,
        0,
      );
      outstanding += assigned.length === 0
        ? 1 + (subscribeCompleted ? 0 : 1)
        : assigned.filter((a) => !a.items.some((i) => i.stepId === 'listings')).length
          + assigned.filter((a) => !a.items.some((i) => i.stepId === 'subscribe')).length;
      this.actionItemsCount = outstanding;
      // Feed the mobile bottom-nav nudge from the same data so the bar above the bottom nav
      // and the desktop pill always show the same call-out.
      this.demoAccountService.setOnboardingNudge(callScheduled, callCompleted, assigned);
      // The pill is already shown (set before the fetch above). If it was already on screen and
      // its contents changed (e.g. dialog closed after completing an action item), flash it so
      // the change is noticed.
      const signature = `${this.livePropertiesCount}/${this.livePropertiesTotal}|${this.actionItemsCount}|${this.callScheduled}|${this.setupCallCompleted}`;
      if (this.lastPillSignature !== null && signature !== this.lastPillSignature) {
        this.flashLivePill();
      }
      this.lastPillSignature = signature;
    } catch {
      // We already passed the isConvertedRentalAccount() gate, so this account SHOULD see the
      // pill — a transient data failure must not hide it. Keep it visible with the last known
      // values; the next successful refresh (dialog close, add:address, auth:complete) fills in
      // fresh counts.
      this.showLivePill = true;
    }
  }

  // Re-arm the attention animation: drop the class, then re-add on the next tick so the
  // CSS animation restarts even if it was already applied.
  private flashLivePill(): void {
    this.livePillAttention = false;
    setTimeout(() => {
      this.livePillAttention = true;
      setTimeout(() => { this.livePillAttention = false; }, 1400);
    }, 50);
  }

  // pm-schedule-call-first: the demo indicator's button label. "Get Started" for control;
  // "Schedule Call" / "Create Account" for the schedule-call-first variant (see DemoAccountService).
  get demoIndicatorLabel(): string {
    return this.demoAccountService.demoIndicatorCta().label;
  }

  // The pill's sub-text — "Ready to get started?" normally, or a "Call scheduled" confirmation
  // once a schedule-call-first visitor has booked their call (button is then "Create Account").
  get demoIndicatorSubtext(): string {
    return this.demoAccountService.demoIndicatorCta().subtext;
  }

  // Show the call icon left of the sub-text only in the post-schedule ("Call scheduled") state,
  // matching the account-manager live pill.
  get demoIndicatorShowCallIcon(): boolean {
    return this.demoAccountService.isScheduleCallFirstVariant() && this.demoAccountService.hasScheduledInDemo();
  }

  openGetStartedFlow = () => {
    // pm-demo-landing experiment funnel: the demo indicator was tapped (desktop pill here,
    // mobile bottom-nav via the 'demo:get-started' event). Fire on every click regardless of
    // the schedule-call-first label so the landing funnel stays intact for both arms.
    this.pmDemoLanding.capture('viewed_create_account');
    // schedule-call-first sends the user to the schedule step (startStep 2) first; control and
    // the post-schedule "Create Account" state both open at step 1.
    const { startStep } = this.demoAccountService.demoIndicatorCta();
    this.rightSidePanelService.setDialogPageTitle(startStep === 2 ? 'Schedule Setup Call' : 'Get Started');
    if (this.windowService.isDesktopRes) {
      // Desktop: right-side dialog. For step 1, pass an explicit (empty) data object so the flow
      // uses it (demo → step 1) rather than stale dialog-params; for step 2 pass the startStep.
      this.rightSidePanelService.openRightSidePanel(GetStartedFlowComponent, startStep === 1 ? {} : { startStep });
    } else {
      // Mobile: full-page route with the flow's own tidy-top-nav + back button. Always pass an
      // explicit startStep so a stale dialog-params startStep can't override it.
      this.rightSidePanelService.navigateTo('get-started', { startStep }, GetStartedFlowComponent);
    }
  }

  // Reopen the flow on the Go Live choice page (projection vs. learn-more) — the same page
  // shown right after account creation — which then leads into scheduling the call.
  openScheduleCall = () => {
    this.rightSidePanelService.setDialogPageTitle('Schedule Setup Call');
    this.rightSidePanelService.openRightSidePanel(GetStartedFlowComponent, { startStep: 2 });
  }

  // The pill's destination depends on onboarding progress: the TIDY AI Property Manager
  // page is only reachable once the setup call is scheduled; until then the pill takes
  // the user to schedule that call.
  openLivePill = () => {
    if (this.callScheduled || this.setupCallCompleted) {
      this.openOnboardingStatus();
    } else {
      this.openScheduleCall();
    }
  }

  openOnboardingStatus = () => {
    this.rightSidePanelService.setDialogPageTitle('My Account');
    this.rightSidePanelService.openRightSidePanel(OnboardingStatusComponent);
  }

  // The mobile onboarding bar (in the bottom nav) routes through here so that leaf nav
  // component doesn't import the wizard. Uses navigateTo (full-page on mobile) and lands on
  // the same screens as the More page: the schedule-call flow until the call is booked, then
  // the "Get Started with TIDY" status page. Refreshes the nudge once the panel closes.
  openMobileOnboardingPill = () => {
    // Still in the demo session (not a converted account): the dashboard "Get Started" must
    // behave EXACTLY like the demo indicator (the bar above the bottom nav) — control →
    // Create Account (step 1); pm-schedule-call-first → Schedule Call (step 2) until they book,
    // then Create Account. Delegate to openGetStartedFlow so the two never diverge.
    if (this.demoAccountService.isDemoSession()) {
      this.openGetStartedFlow();
      return;
    }
    if (this.callScheduled || this.setupCallCompleted) {
      this.rightSidePanelService.setDialogPageTitle('My Account');
      this.rightSidePanelService.navigateTo('get-started-status', {}, OnboardingStatusComponent);
    } else {
      this.rightSidePanelService.setDialogPageTitle('Schedule Setup Call');
      this.rightSidePanelService.navigateTo('get-started', { startStep: 2 }, GetStartedFlowComponent);
    }
    this.rightSidePanelService.panelClosed().subscribe(() => this.refreshLivePill());
  }

  openAccountManager = () => {
    this.rightSidePanelService.setDialogPageTitle('Your Account Manager');
    this.rightSidePanelService.openRightSidePanel(AccountManagerModalComponent, { smallDisplay: true });
  }

  dismissDemoWelcome = () => {
    // The backdrop renders during 'reveal' too (pre-blur under the sweep);
    // only a visible welcome card can be dismissed
    if (this.demoWelcomeLeaving || this.demoAccountService.entrancePhase() !== 'welcome') {
      return;
    }
    this.demoWelcomeLeaving = true;
    setTimeout(() => {
      this.demoAccountService.dismissWelcome();
      this.demoWelcomeLeaving = false;
      // Welcome card dismissed → hand off to the guided tour of the demo pages (the
      // pm-demo-tour experiment's `guided-tour` arm; a no-op for control, on mobile,
      // and if the tour was already completed or skipped).
      this.demoTourService.startAfterWelcome().catch(() => { /* never block the demo flow */ });
    }, 320);
  }

  addPopStateListener() {
    this.popstateHandler = async (event: PopStateEvent) => {
      this.storage.save('dialog-right-side-open', false);
      if (event.state?.guestSessionStart) {
        const isGuestAccount = await this.storage.retrieve('isGuestAccount');
        // The `guestSessionStart` entry is only meant to exist for genuine guest sessions, but
        // it also gets stamped at bootstrap whenever isAuthenticated() reads a transient false
        // (tidy_token slow to rehydrate / localStorage momentarily null on iOS). On iOS native
        // the WebView emits a popstate when the keyboard opens, which would then throw an authed
        // client back to native-landing mid-conversation. Re-check auth now that the token has
        // had time to rehydrate: never navigate away if the user is actually authenticated.
        if (isGuestAccount && !this.auth.isAuthenticated() && !this.authModalService.isOpen()) {
          history.pushState({}, '');
          if (this.isNativePlatform) {
            this.navCtrl.navigateRoot('native-landing');
          } else {
            this.authModalService.openGuestTypeModal();
          }
        }
      }
    };
    window.addEventListener('popstate', this.popstateHandler);
  }

  preventiveRemoveAriaOwns() {
    this.domNodeInsertedHandler = () => {
      const elements = document.querySelectorAll('[aria-owns]');
      elements.forEach(element => {
        element.removeAttribute('aria-owns');
      });
    };
    document.addEventListener('DOMNodeInserted', this.domNodeInsertedHandler);
  }

	initDeeplinks() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const url = new URL(event.url);

        // Handle URLs with query parameters (OAuth callbacks)
        if (url.searchParams.has('integrationType') && url.searchParams.has('code')) {
          const integrationType = url.searchParams.get('integrationType');
          const code = url.searchParams.get('code');
          this.storage.save('integrationCode', code);
          this.navCtrl.navigateForward(`authorization/${integrationType}?code=${code}`);
          return;
        }

        // Handle path-based URLs (new format)
        if (url.pathname && url.pathname !== '/') {
          const appPath = url.pathname.startsWith('/') ? url.pathname.substring(1) : url.pathname;
          if (appPath) {
            this.navCtrl.navigateForward(appPath + url.search);
            return;
          }
        }

        // Handle legacy hash-based URLs (backward compatibility)
        if (url.hash && url.hash.startsWith('#/')) {
          const appPath = url.hash.substring(2);
          if (appPath) {
            this.navCtrl.navigateForward(appPath);
            return;
          }
        }

        this.navCtrl.navigateForward('login');
      });
    });
	}

  trackUserNavigation(event) {
    const tidySessionId = this.tidySession.configureTidySessionCookie();
    let pageName = "";
    if (event.snapshot && event.snapshot.data && event.snapshot.data.title) {
      pageName = event.snapshot.data.title;
    }
    const data: TrackParams = {
      tidySessionId,
      eventType: "PAGE_LOAD",
      metaData: "",
      pageName,
    };
    this.tidySession.trackEvent(data);
  }

  subscribeEvents() {
    this.eventSubscriptions.push(
      this.events.subscribe("authToken:isInvalid", () => {
        // Ignore auth invalidation from the OUTGOING session while a login-as-client swap is
        // underway — logging out here would wipe the freshly minted session and bounce the user
        // to the auth modal (see Auth.beginTokenLogin).
        if (this.auth.isTokenLoginInProgress()) {
          return;
        }
        this.logout();
      }),
      this.events.subscribe("logout", () => this.logout()),
      this.events.subscribe("updateBackground", () => this.setBackground()),
      this.events.subscribe("address:changed", (address) => this.addressChanged(address)),
      this.events.subscribe("menu:open", () => this.toggleMenu(true)),
      this.events.subscribe("menu:close", () => this.toggleMenu(false)),
      this.events.subscribe("global-search:open", () => this.openSearchOverlay()),
      this.events.subscribe("auth:complete", () => {
        this.sseService.connect([...SSE_EVENT_TYPES]);
        this.refreshLivePill();
      }),
      // Fires after the demo -> real account conversion, when the live pill
      // should replace the demo pill.
      this.events.subscribe("updateMenu", () => this.refreshLivePill()),
      // A property added anywhere (Addresses.createAddress publishes 'add:address') should
      // immediately update the "X of Y properties live" count in the bottom pill.
      this.events.subscribe("add:address", () => this.refreshLivePill()),
      // The mobile demo bar (in the bottom nav) opens the Get Started flow through here so
      // that leaf component doesn't need to import the wizard.
      this.events.subscribe("demo:get-started", () => this.openGetStartedFlow()),
      // The mobile onboarding bar (in the bottom nav) routes the same way the More page does.
      this.events.subscribe("onboarding:open-pill", () => this.openMobileOnboardingPill())
    );
    this.platform
      .ready()
      .then(() => this.platformReady())
      .catch((err) => this.logger.log(`Err on platform.ready: ${  err}`));
    this.loadingBarHandler.setup();
    this.searchSubscription = this.searchControl.valueChanges.subscribe((value) => {
      this.filterSearchItems(value);
    });
  }

  setTitle(event) {
    const { title, tabTitle } = event.state.root.children[0].data;
    this.titleService.setTitle(tabTitle || title);
  }

  setNameAddress() {
    if (
      typeof this.nameAndAddress === "undefined" ||
      !this.nameAndAddress.custumerId
    ) {
      this.nameAndAddress = this.mainMenu.getNameAndAddress();
      this.nameAndAddress.address = this.addresses.getCurrentAddress();
    }
  }

  isNative(): boolean {
    return this.platform.is("hybrid");
  }

  toggleMenu(enableMenu) {
    this.enableMenu = enableMenu;
  }

  addressChanged(address) {
    if (!address) {
      return;
    }
    this.addresses.setCurrentAddress(address);
    this.nameAndAddress.address = this.addresses.getCurrentAddress();
  }

  platformReady(): void {
    if (this.isNative()) {
      SplashScreen.hide();
      Keyboard.setAccessoryBarVisible({ isVisible: false });
      // Set native padding for mobile modal only on iOS
      if (Capacitor.getPlatform() === 'ios') {
        document.documentElement.style.setProperty('--goals-native-padding-top', '8rem');
        document.body.classList.add('ios-native');
      }
      // Add Android-specific class for safe area handling
      if (Capacitor.getPlatform() === 'android') {
        document.body.classList.add('android-platform');
      }
    }
    this.askTrackingPermission();
    this.initPushNotifications();
    // The minimum-version check reads a PostHog flag, so it runs once PostHog is set up and
    // the customer identified.
    this.initPostHog().finally(() => this.appUpdateService.start());
  }

  private async initPostHog(): Promise<void> {
    // One-time fix: clear poisoned sticky cache for users who got 'control'
    // due to the setPersonPropertiesForFlags ordering bug (flag returned false
    // without environment property, which was cached as 'control').
    if (!localStorage.getItem('posthog_cache_fix_1')) {
      localStorage.removeItem('posthog_variant_residential-booking-view');
      localStorage.setItem('posthog_cache_fix_1', '1');
    }

    const initialized = await this.posthogService.setup();
    if (!initialized) {
      this.posthogService.completeIdentification();
      return;
    }

    // Wait for initial flags to load — ensures the onFeatureFlags callback
    // from setup() has fired before we call identify() + reloadFeatureFlags(),
    // preventing the stale callback from resolving the reload promise.
    await this.posthogService.waitForFlags();

    // Demo sessions must stay on the anonymous per-device distinct_id. The demo account
    // (demos@tidy.com) is shared, so identifying as it collapses every demo visitor onto a
    // single PostHog person — which corrupts experiment bucketing (everyone resolves to one
    // fixed variant, i.e. control) and breaks the anonymous -> real-account stitching that
    // attributes conversions. This bit /create-account/rental specifically: loginToDemoAccount
    // (route ngOnInit) authenticates before this check runs, so without the isDemoSession()
    // guard initPostHog would take the authenticated branch and identify() as the demo account.
    // The auth-modal path is already anonymous here because initPostHog ran before the click.
    if (!this.auth.isAuthenticated() || this.demoAccountService.isDemoSession()) {
      this.posthogService.completeIdentification();
      return;
    }

    try {
      let customerId = localStorage.getItem('customer_id');
      let customerEmail = localStorage.getItem('customer_email');
      let accountType = localStorage.getItem('accountType');

      if (!customerId || !customerEmail) {
        try {
          const data = await this.client.getMe([], true);
          customerId = String(data?.customer_account?.id ?? '');
          customerEmail = data?.current_user?.email ?? '';
          accountType = data?.customer_account?.account_type ?? '';
          if (customerId) {localStorage.setItem('customer_id', customerId);}
          if (customerEmail) {localStorage.setItem('customer_email', customerEmail);}
          if (accountType) {localStorage.setItem('accountType', accountType);}
        } catch (err) {
          console.error('PostHog: Failed to fetch user data for identification:', err);
        }
      }

      // Belt-and-suspenders for the isDemoSession() guard above: never identify as the shared
      // demo account, even if the demo flag was momentarily unset during the login's storage churn.
      if (customerId && customerEmail && customerEmail !== DEMO_ACCOUNT_EMAIL) {
        await this.posthogService.identify(
          parseInt(customerId, 10),
          customerEmail,
          { account_type: accountType }
        );
        await this.posthogService.reloadFeatureFlags();
        await this.bookService.cacheBookingViewV2Variant();
      }
    } finally {
      this.posthogService.completeIdentification();
    }
  }

  askTrackingPermission() {
    if (this.platform.is("cordova") && this.platform.is("ios")) {
      if (window.cordova) {
        window.cordova.exec(null, null, "idfa", "requestPermission", []);
      }
    }
  }

  setVersion() {
    window.tidyAppVersion = environment.version;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    const newWidth = event.currentTarget.innerWidth;
    this.width = newWidth;
    this.menuType = newWidth > this.breakLargeResolution ? "desktop" : "mobile";
  }

  @HostListener("window:keydown", ["$event"])
  onGlobalKeydown(event: KeyboardEvent) {
    // Cmd+S (Mac) / Ctrl+S (Windows/Linux) opens the global search overlay.
    // Overrides the browser's "Save Page As..." default.
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 's') {
      event.preventDefault();
      if (!this.showSearchOverlay) {
        this.openSearchOverlay();
      }
    }
  }

  setBackground() {
    const isCompany = this.staticCompanyText.isCompany();
    const componentElem = this.elementRef.nativeElement as HTMLElement;
    componentElem.style.backgroundImage = '';
    componentElem.style.backgroundColor = '';
    componentElem.className = isCompany ? "company" : "regular";
  }

  // The rental "guest account" entry flow was replaced by the demo-account
  // paradigm. A user still sitting in an OLD rental guest session (a guest
  // account, not the new demo session) is logged out on app open so they
  // re-enter through the new flow. Non-rental (home / office) guests are left
  // untouched — they still use guest accounts — as is the demo session itself.
  private async logoutIfStaleRentalGuest(): Promise<void> {
    if (localStorage.getItem('isDemoAccount') === 'true') {
      return;
    }
    const isGuestAccount = await this.storage.retrieve('isGuestAccount');
    if (!isGuestAccount) {
      return;
    }
    const isRentalGuest =
      localStorage.getItem('isRentalClient') === 'true' ||
      localStorage.getItem('guest_view_type') === 'rental' ||
      localStorage.getItem('airbnb') === 'true';
    if (!isRentalGuest) {
      return;
    }
    await this.logout();
  }

  @Loading("Loading...")
  async logout() {
    const wasLoggedOutDueToCacheIssue = localStorage.getItem('wasLoggedOutDueToCacheIssue') === 'true';
    this.sseService.disconnect();
    // Clear TanStack Query cache to prevent data leakage between accounts
    this.queryClient.clear();
    CustomRouteReuseStrategy.clearStoredRoutes();
    await this.posthogService.reset();
    document.cookie = 'tidy_logged_in=; path=/; max-age=0';
    const themeMode = localStorage.getItem('tidy_theme_mode');
    const themeUserSet = localStorage.getItem('tidy_theme_user_set');
    localStorage.clear();
    if (themeMode) {
      localStorage.setItem('tidy_theme_mode', themeMode);
    }
    if (themeUserSet) {
      localStorage.setItem('tidy_theme_user_set', themeUserSet);
    }
    await this.storage.clear();
    this.menu.close();
    this.setBackground();
    this.nameAndAddress = undefined;
    if (wasLoggedOutDueToCacheIssue) {
      localStorage.setItem('wasLoggedOutDueToCacheIssue', 'true');
    }
    window.location.href = '/overview';
  }

  goToPage(page) {
    if (page === "Help") {
      return this.goToZendesk();
    }

    this.menu.close();

    const rootPages = [
      "schedule-assurance-confirm",
      "cancel-cleaning",
      "to-dos-settings",
    ];
    if (rootPages.indexOf(page) > -1) {
      this.navCtrl.navigateForward(page);
    } else {
      this.navCtrl.navigateRoot(page, navRootOptions);
    }
  }

  isUnsupportedBrowser() {
    if (Capacitor.isNativePlatform()) {
      return;
    }
    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserName = browser.getBrowserName();
    const browserVersion = browser.getBrowserVersion();
    const osName = browser.getOSName();
    const osVersion = browser.getOSVersion();

    if (this.windowService.isDesktopRes) {
      if (browserName === 'Internet Explorer' || (browserName === 'Safari' && browserVersion && parseInt(browserVersion, 10) < 9)) {
        window.location.href = "https://secure.tidy.com";
        return;
      }
    }

    const isOldiOS = osName === 'iOS' && osVersion && parseInt(osVersion, 10) < 16;
    const isOldSafari = browserName === 'Safari' && browserVersion && parseInt(browserVersion, 10) < 16;

    if (isOldiOS || isOldSafari) {
      const version = isOldiOS ? `iOS ${osVersion}` : `Safari ${browserVersion}`;
      this.util.showAlert(
        'Unsupported Version',
        `You are using ${version}, which may not fully support all features of this app. For the best experience, please update to iOS 16+ or Safari 16+.`,
        true,
        [{ text: 'OK', role: 'cancel' }]
      );
    }
  }

  openCloseAddressSelector() {
    this.addressSelectorOpened = !this.addressSelectorOpened;
  }

  goToMainPage(address) {
    this.events.publish("address:changed", address);
    this.navCtrl.navigateForward("my-cleanings");
    this.menu.close();
  }

  goToZendesk() {
    const url = "https://www.tidy.com/docs/pm/getting-started";
    this.util.openUrl(url);
  }

  initPushNotifications(): void {
    if (Capacitor.isNativePlatform()) {
      setTimeout(() => {
        this.oneSignalNotification.initOneSignal().catch((error) => {
          this.logger.log(`OneSignal initialization error: ${error}`);
        });
      }, 1000);
    }
  }


  toggleNavCollapse() {
    this.isNavCollapsed = !this.isNavCollapsed;
    localStorage.setItem('navMenuCollapsed', this.isNavCollapsed.toString());
    this.events.publish('toggle:nav:collapse');
  }

  async openSearchOverlay() {
    this.showSearchOverlay = true;
    await this.loadSearchItems();
    setTimeout(() => {
      if (this.globalSearchInput) {
        this.globalSearchInput.nativeElement.focus();
      }
    }, 100);
  }

  closeSearchOverlay(event?: Event) {
    this.showSearchOverlay = false;
    this.searchControl.setValue('');
    this.filteredSearchItems = [];
  }

  clearSearch() {
    this.searchControl.setValue('');
  }

  async loadSearchItems() {
    // Gating lives on the page rows themselves (rentalOnly / longTermOnly)
    // so search and the desktop nav can't drift apart.
    const pages = this.headerProvider.getSearchablePages();
    const isEmployerAccount = localStorage.getItem('accountType') === 'employer';
    if (isEmployerAccount) {
      this.searchItems = [
        {
          list: 'PAGES',
          items: pages
        },
        {
          list: 'HELP ARTICLES',
          items: this.headerProvider.helpArticlesItems
        },
      ];
      this.filteredSearchItems = this.searchItems;
      return;
    }
    try {
      const addressList = await this.client.getAddresses();
      const parsedAddressList = this.parseAddressList(addressList);
      const prosData = await this.pros.getAllPros();
      const parsedPros = this.parsePros(prosData);
      this.searchItems = [
        {
          list: 'PROPERTIES',
          items: parsedAddressList
        },
        {
          list: 'PROS',
          items: parsedPros
        },
        {
          list: 'PAGES',
          items: pages
        },
        {
          list: 'HELP ARTICLES',
          items: this.headerProvider.helpArticlesItems
        },
      ];
      this.filteredSearchItems = this.searchItems;
      this.reportUnsearchableItems();
    } catch (_error) {
      this.searchItems = [
        {
          list: 'PAGES',
          items: pages
        },
        {
          list: 'HELP ARTICLES',
          items: this.headerProvider.helpArticlesItems
        },
      ];
      this.filteredSearchItems = this.searchItems;
    }
  }

  // Logging for Sentry CLIENT-APP-5W0: an item without a string title makes
  // filterSearchItems() throw on every keystroke. Says which list and link it is.
  private reportUnsearchableItems() {
    const items = findUnsearchableItems(this.searchItems);
    if (!items.length) {
      return;
    }
    Sentry.captureMessage('Global search has items without a string title', {
      level: 'warning',
      extra: { items },
    });
  }

  parseAddressList(addressList: any[]) {
    return addressList.map((address) => {
      const addressName = this.getPropertyName(address);
      return {
        list: 'Properties',
        title: addressName,
        link: `properties?propertyId=${address.id}`,
        image: 'assets/img/house-white.svg'
      };
    });
  }

  getPropertyName(address: any): string {
    if (address.address_name) {
      return address.address_name;
    }
    if (address?.address2 && address?.address2 !== '') {
      return `${address.address1}, ${address.address2}`;
    }
    return address.address1;
  }

  parsePros(prosData: any[]) {
    return prosData.map((pro) => ({
      list: 'Pros',
      title: pro?.name ? new TidyAbbreviateLastName().transform(pro.name) : '',
      link: `my-pro/${pro.id}`,
      image: 'assets/img/user-white.svg',
      isRightSidePanel: true,
      component: MyProPage,
      params: {
        proId: pro.id
      }
    }));
  }

  filterSearchItems(searchValue: string) {
    this.selectedSearchItem = null;
    if (!searchValue || !this.searchItems) {
      this.filteredSearchItems = this.searchItems;
      return;
    }
    const translationPipe = new TranslationPipe();
    this.filteredSearchItems = this.searchItems
      .map((section) => ({
        ...section,
        items: section.items.filter((item) =>
          translationPipe.transform(item.title).toLowerCase().includes(searchValue.toLowerCase()) ||
          item?.searchTerms?.some(term => translationPipe.transform(term).toLowerCase().includes(searchValue.toLowerCase()))
        ),
      }))
      .filter((section) => section.items.length > 0);
  }

  handleSearchKeydown(event: KeyboardEvent) {
    const items = this.filteredSearchItems?.flatMap(s => s.items) || [];
    if (!items.length) {return;}
    const currentIndex = this.selectedSearchItem ? items.indexOf(this.selectedSearchItem) : -1;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.selectedSearchItem = items[Math.min(currentIndex + 1, items.length - 1)];
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.selectedSearchItem = currentIndex > 0 ? items[currentIndex - 1] : null;
    } else if (event.key === 'Enter' && this.selectedSearchItem) {
      event.preventDefault();
      this.handleSearchItemClick(this.selectedSearchItem);
    }
  }

  async handleSearchItemClick(item: any) {
    this.closeSearchOverlay();
    if (item.title === 'Book Job(s)') {
      await this.bookService.goToBookJob({});
      return;
    }
    if (item?.link === '/contacts' && !this.windowService.isDesktopRes) {
      item.link = '/job-request-workflows';
    }
    if (item?.link) {
      if (item?.link.includes('https://')) {
        this.util.openUrl(item.link);
      } else {
        if (item.isRightSidePanel) {
          this.storage.save('dialog-right-side-open', true);
          this.storage.save('dialog-params', item?.params);
          this.rightSidePanelService.openRightSidePanel(item?.component);
        } else {
          if (item.link.startsWith('properties?propertyId=') && this.router.url.startsWith(propertyDashboardPath())) {
            const propertyIdMatch = item.link.match(/propertyId=(\d+)/);
            if (propertyIdMatch) {
              this.addressChangeService.changeAddress(parseInt(propertyIdMatch[1]));
            }
          } else {
            this.navCtrl.navigateForward(item.link);
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.searchSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    this.eventSubscriptions.forEach(sub => sub?.unsubscribe());
    if (this.popstateHandler) {
      window.removeEventListener('popstate', this.popstateHandler);
    }
    if (this.domNodeInsertedHandler) {
      document.removeEventListener('DOMNodeInserted', this.domNodeInsertedHandler);
    }
  }
}
